import React from 'react';
import {
    Radar,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    ResponsiveContainer,
    Tooltip
} from 'recharts';

/**
 * SkillRadar Component
 * Professional SIRH version (Simple Blue/Coral)
 */
const SkillRadar = ({ data, compact = false, title, subtitle }) => {
    if (!data || data.length === 0) {
        return (
            <div className="eval-empty">
                <p>Aucune donnee disponible pour generer le radar.</p>
            </div>
        );
    }

    return (
        <div className={`radar-container radar-container--side${compact ? ' radar-container--compact' : ''}`}>
            <aside className="radar-side-panel">
                {(title || subtitle) && (
                    <div className="radar-user-summary">
                        {title && <strong>{title}</strong>}
                        {subtitle && <span>{subtitle}</span>}
                    </div>
                )}
                <div className="radar-side-legend">
                    <div><i style={{ background: '#2f4595' }} /> Niveau collaborateur</div>
                    <div><i style={{ background: '#2f4595' }} /> Score requis</div>
                </div>
            </aside>

            <div className="radar-chart-panel">
                <ResponsiveContainer width="100%" height="100%">
                    <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
                        <PolarGrid stroke="#e2e8f0" />
                        <PolarAngleAxis
                            dataKey="skill"
                            tick={{ fill: '#475569', fontSize: compact ? 9 : 11, fontWeight: 600 }}
                        />
                        <PolarRadiusAxis
                            angle={30}
                            domain={[0, 4]}
                            tick={{ fill: '#94a3b8', fontSize: compact ? 8 : 10 }}
                        />

                        <Radar
                            name="Score requis"
                            dataKey="requis"
                            stroke="#2f4595"
                            fill="none"
                            strokeWidth={1.15}
                            dot={{ r: compact ? 2 : 2.6, fill: '#2f4595', stroke: '#2f4595' }}
                        />

                        <Radar
                            name="Niveau collaborateur"
                            dataKey="obtenu"
                            stroke="#2f4595"
                            fill="none"
                            strokeWidth={1.15}
                            dot={{ r: compact ? 2 : 2.6, fill: '#2f4595', stroke: '#2f4595' }}
                        />

                        <Tooltip
                            contentStyle={{
                                borderRadius: '8px',
                                border: '1px solid #e2e8f0',
                                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)'
                            }}
                        />
                    </RadarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default SkillRadar;
